import http from '@/communication/AuthConnection'

const readFile = ({ file, eventId }) => {
  const formData = new FormData()
  formData.append('fileCSV', file)
  formData.append('eventId', eventId)
  return http
    .post('/v1/event/upload-items', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/components/event/insert-items/FileHandle.js